import * as React from "react";
import { MetaTags } from "../../../head";

const QA = () => [
  <MetaTags key={0} title="Q&amp;A" />,
  <div key={1} className="tab-pane active">
    <MetaTags title="Q&amp;A" />
    <h1>Q&amp;A</h1>
    <h3>Làm thế nào đặt hàng của Express design</h3>
    <p>B1: Chọn sản phẩm</p>
    <p>B2: Lựa chọn phong cách thiết kế</p>
    <p>B3: Lựa chọn phong cách tông màu chủ đạo</p>
    <p>B4: Điền thông tin về sản phẩm của bạn</p>
    <p>B5: Nhân viên của Express Design sẽ gọi điện và xác nhận đơn hàng</p>
    <p>Chúng tôi sẽ nhận thông tin của bạn.</p>

    <h3>Có bắt buộc tạo tài khoản trước khi đặt hàng không?</h3>
    <p>Bạn có thể đặt hàng tại Express Design mà không cần đăng ký.</p>
    <p>
      Tuy nhiên, nhằm phục vụ tiện ích trong quá trình đặt hàng, chúng tôi
      khuyến khích bạn đăng ký tạo tài khoản đặt hàng tại Express Design để sử
      dụng những tính năng mới nhất sẽ được cập nhật liên tục,đồng thời tham gia
      chương trình dành cho khách hàng thân thiết.
    </p>

    <h3>Tôi có thể đặt nhiều sản phẩm cùng một lúc được không?</h3>
    <p>
      Express Design nhận tất cả các sản phẩm thiết kế của bạn yêu cầu bao gồm
      thiết kế đơn lẻ hoặc trọn gói bộ sản phẩm.
    </p>

    <h3>Tôi có được tư vấn về sản phẩm của tôi không?</h3>
    <p>
      Express design luôn tạo điều kiện tốt nhất cho bạn đặc biệt về tư vấn và
      hỗ trợ để cung cấp những sản phẩm đẹp nhất và ưng ý nhất.
    </p>
    <p>
      Ngay sau khi nhận được đơn hàng yêu cầu thiết kế của khách hàng, nhân viên
      tư vấn của Express Design sẽ liên hệ ngay lập tức, tư vấn cho khách hàng
      về các yếu tố như: màu sắc, mục đích sử dụng, giới thiệu nhà in, hướng dẫn
      thanh toán,...
    </p>
    <p>
      Nếu khách hàng chưa định hình được sản phẩm của mình, khách hàng có thể để
      lại số điện thoại và Express Design sẽ liên hệ để hỗ trợ khách hàng đặt
      hàng thiết kế.
    </p>

    <h3>
      Tôi có thể yêu cầu đặc biệt đối với sản phẩm của mình có được không?
    </h3>
    <p>
      Bạn hoàn toàn có thể yêu cầu đặc biệt đối với sản phẩm thiết kế như: Thiết
      kế lại 1 sản phẩm sẵn có, Vẽ tay các chi tiết, dựng 3D sản phẩm, lồng
      mock-up (mẫu mô phỏng sản phẩm thật),...
    </p>

    <h3>Tôi có được nhận ưu đãi khi đặt nhiều sản phẩm ?</h3>
    <p>
      Bạn sẽ được nhận ưu đãi khi đặt hàng tại Express Design khi đặt nhiều sản
      phẩm một lúc (dạng gói sản phẩm trọn bộ). Hãy trao đổi những yêu cầu của
      bạn khi nhân viên tư vấn gọi đến để được mức giá ưu đãi nhất.
    </p>

    <h3>Tôi có thể lấy sản phẩm sớm hơn so với thời gian quy định?</h3>
    <p>
      Bạn có thể tùy chọn thêm dịch vụ “Super Express” để có thể nhận sản phẩm
      thiết kế sớm hơn thời lượng hiển thị trong lúc đặt hàng.
    </p>

    <h3>Tôi có phải thanh toán trước không ?</h3>
    <p>
      Hầu hết các sẩn phẩm thiết kế của Express Design không yêu cầu thanh toán
      trước, khách hàng sẽ thanh toán trước khi nhận sản phẩm thiết kế cuối cùng
      (thường là file thiết kế gốc, ảnh chất lượng cao,...) Tuy nhiên với một số
      sản phẩm đặc thù, bạn cần thanh toán trước tối thiểu 50%. Thông tin sẽ
      được hiển thị công khai trên website khi bạn đặt hàng.
    </p>

    <h3>
      Khi nhận được sản phẩm nhưng tôi không ưng ý, tôi có mất phí để chỉnh sửa
      lại sản phẩm không?
    </h3>
    <p>
      Express Design không giới hạn lần sửa trong một đơn hàng. Việc chỉnh sửa
      sẽ kết thúc sau khi khách hàng thanh toán và download sản phẩm. Nếu khách
      hàng có nhu cầu chỉnh sửa sau khi giao dịch kết thúc, khách hàng có thể
      liên hệ để trao đổi trực tiếp với nhân viên tư vấn.
    </p>

    <h3>
      Tôi được thiết kế và chỉnh sửa sản phẩm của tôi tối đa bao nhiêu mẫu?
    </h3>
    <p>
      Với tùy từng sản phẩm, Express Design sẽ gửi cho khách hàng từ 1 - 3 mẫu
      trong lần đầu để khách hàng lựa chọn. Nếu ưng ý, khách hàng có thể thanh
      toán và nhận ngay sản phẩm hoặc yêu chỉnh sửa thêm. Express Design không
      giới hạn số lần sửa 1 mẫu cho bạn.
    </p>
    <p>
      Trong trường hợp chỉnh sửa quá 50% lượng nội dung so với mẫu ban đầu được
      khách hàng lựa chọn (tính theo các yếu tố về màu sắc, nội dung chữ, bố
      cục,...) khách hàng sẽ phải thanh toán trước 50% giá trị sản phẩm để được
      tiếp tục chỉnh sửa.
    </p>

    <h3>Nếu tôi thanh toán trước thì có được giảm giá không ?</h3>
    <p>
      Express Design khuyến khích khách hàng thanh toán trước tối thiểu 50% giá
      trị sản phẩm để được nhận khuyến mãi về giá (Trừ trực tiếp vào sản phẩm)
    </p>

    <h3>Tôi có thể thanh toán bằng cách nào?</h3>
    <p>
      Khách hàng có thể chuyển khoản qua ngân hàng hoặc thanh toán qua ví điện
      tử Momo
    </p>
    <p>
      Express Design sẽ cung cấp dịch vụ thanh toán bằng thẻ thanh toán quốc tế
      trong thời gian tới.
    </p>
    <p>Xem danh sách ngân hàng tại đây</p>

    <h3>Tôi nhận sản phẩm bằng cách nào?</h3>
    <p>
      Chúng tôi sẽ gửi file sản phẩm trực tiếp trên hệ thống và qua thư điện tử
      (email) cho bạn.
    </p>

    <h3>
      Tôi đã có file thiết kế nhưng đã làm mất, làm thế nào tôi có thể lấy lại ?
    </h3>
    <p>
      Bạn có thể tìm lại sản phẩm thiết kế bằng cách truy cập vào tài khoản của
      mình hoặc liên hệ trưc tiếp tới bộ phận chăm sóc khách hàng tại Hotline:{" "}
      <a href="tel:+842466602466">+84 24-6660-2466</a>
    </p>

    <h3>Công ty có in ấn sản phẩm ra không?</h3>
    <p>
      Express Design có thể giới thiệu với bạn một số nhà in uy tín trên địa bàn
      Hà Nội và Nam Định, đối với các tỉnh thành khác, chúng tôi sẽ cập nhật
      dịch vụ sớm nhất có thể.
    </p>

    <h3>Làm thế nào tôi có thể theo dõi trình trạng đơn hàng của tôi ?</h3>
    <p>
      Sau khi đặt hàng, bạn nhận được đơn xác nhận qua email của bạn cung cấp.
      Bạn có thể theo dõi đơn hàng qua email và trên hệ thống bằng cách đăng
      nhập vào tài khoản của mình
    </p>

    <h3>Tôi có thể hủy đơn hàng được không?</h3>
    <p>
      Bạn có thể hủy đơn hàng tuy nhiên bạn sẽ không nhận lại được số tiền đã
      thanh toán trước.
    </p>

    <h3>Thông tin đơn hàng/tài khoản chưa chính xác và có nhu cầu thay đổi?</h3>
    <p>
      Bạn có thể điều chỉnh thông tin đơn hàng/tài khoản qua email hoặc liên hệ
      trực tiếp với chúng tôi qua Hotline:{" "}
      <a href="tel:+842466602466">+84 24-6660-2466</a>
    </p>

    <h3>Tôi có thể đặt hàng qua điện thoại không?</h3>
    <p>Chúng tôi có thể hỗ trợ bạn đặt hàng qua điện thoại.</p>
    <p>
      Tuy nhiên chúng tôi khuyến khích bạn tìm hiểu thêm về cách đặt hàng trực
      tuyến tại Expressdesign.vn với các tính năng công nghệ hỗ trợ cao nhằm đảm
      bảo chất lượng của đơn hàng.
    </p>

    <h3>Sau khi đặt hàng tôi có nhận được đơn xác nhận nào không?</h3>
    <p>
      Ngay sau khi đơn hàng được đặt thành công. Express Design sẽ gửi tin nhắn
      và email thông báo đến bạn xác nhận đã nhận yêu cầu đặt hàng với mã số đơn
      hàng kèm theo.
    </p>
    <p>
      Trong một số trường hợp Express Design cần xác nhận đơn hàng từ bạn, chúng
      tôi có thể sẽ liên hệ với bạn qua điện thoại, sẽ thực hiện cuộc gọi đến số
      điện thoại bạn đã đăng ký. Cuộc gọi xác nhận đơn hàng sẽ được thực hiện 3
      lần, nếu sau 3 lần Express Design vẫn chưa nhận được xác nhận của bạn,
      chúng tôi có thể sẽ tiến hành gửi tin nhắn đề nghị xác nhận đơn hàng đến
      bạn. Bạn vui lòng thực hiện theo hướng dẫn từ nội dung được gửi đến. Nếu
      quá thời gian đề cập mà vẫn chưa nhận được thông tin từ bạn, chúng tôi rất
      tiếc sẽ ngừng thực hiện đơn hàng trên hệ thống.
    </p>
    <p>
      Tình trạng đơn hàng sẽ được cập nhật qua email và trong tài khoản để bạn
      kịp thời theo dõi.
    </p>
  </div>,
];

export default QA;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/QA.tsx